// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1TeamSchema } from './v1/teamSchema';

export const get11AccountIdTeamsIdPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID for the team you want to retrieve"),
  id: z.number().int().describe("Team ID to retrieve"),
});

export const get11AccountIdTeamsIdHeaderParamsSchema = z.object({
  Authorization: z.coerce.string(),
});

/**
 * @description Team details
 */
export const get11AccountIdTeamsId200Schema = z.lazy(() => v1TeamSchema);

/**
 * @description Forbidden - Insufficient permissions to read team
 */
export const get11AccountIdTeamsId403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Team not found
 */
export const get11AccountIdTeamsId404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const get11AccountIdTeamsIdQueryResponseSchema = z.lazy(() => get11AccountIdTeamsId200Schema);
